<script setup>
import { computed, onMounted, ref, nextTick } from "vue";
import { useTimesheetStore } from "@/stores/timesheetStore";
import TimesheetsTable from "./timesheets-table.vue";
import TimesheetsModal from "@/components/modal/timesheets-modal.vue";
import Modal from "bootstrap/js/dist/modal";

const store = useTimesheetStore();
const editItem = ref(null);

function openAdd(){ Modal.getOrCreateInstance(document.getElementById("add_timesheet"))?.show(); }
function openEdit(row){ editItem.value=row; nextTick(()=>Modal.getOrCreateInstance(document.getElementById("edit_timesheet"))?.show()); }

async function confirmDelete(row){ if(!row?.id) return; if(!confirm("Delete this timesheet?")) return; await store.remove(row.id); }
const totalPages = computed(()=>{ const t=store.pagination.total||0,p=store.pagination.per_page||25; return Math.max(1,Math.ceil(t/p)); });

onMounted(async ()=>{ await store.fetchMine({ page: 1 }); });
function onSaved() {
  editItem.value = null;
  store.refreshList();
}
</script>

<template>
  <layout-header/><layout-sidebar/>
  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb title="My Timesheets" text="Attendance" text1="My Timesheets" />
        <div class="mb-2">
          <a href="javascript:void(0);" class="btn btn-primary d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#add_timesheet" @click="openAdd">
            <i class="ti ti-circle-plus me-2"></i>Add Today’s Work
          </a>
        </div>
      </div>

      <!-- Optional quick filters for mine -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row g-2 align-items-end">
            <div class="col-md-3">
              <label class="form-label">Search / Project</label>
              <input v-model="store.filters.search" type="text" class="form-control" placeholder="project, notes..." />
            </div>
            <div class="col-md-2">
              <label class="form-label">From</label>
              <input v-model="store.filters.date_from" type="date" class="form-control"/>
            </div>
            <div class="col-md-2">
              <label class="form-label">To</label>
              <input v-model="store.filters.date_to" type="date" class="form-control"/>
            </div>
            <div class="col-md-2 d-grid">
              <button class="btn btn-primary" @click="store.fetchMine({ page: 1 })">Filter</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header"><h5>My Timesheet</h5></div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <timesheets-table :rows="store.items" :loading="store.loading" @edit="openEdit" @delete="confirmDelete" />
          </div>
          <div class="p-3 d-flex justify-content-between align-items-center">
            <div>Showing page {{ store.pagination.current_page }} of {{ totalPages }}</div>
            <div class="btn-group">
              <button class="btn btn-outline-secondary" :disabled="store.pagination.current_page<=1" @click="store.fetchMine({ page: store.pagination.current_page - 1 })">Prev</button>
              <button class="btn btn-outline-secondary" :disabled="store.pagination.current_page>=totalPages" @click="store.fetchMine({ page: store.pagination.current_page + 1 })">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a></p>
    </div>
  </div>

  <timesheets-modal :edit-item="editItem" @saved="onSaved" />
</template>


